import { render } from "./ListVehicles.vue?vue&type=template&id=dacf8172&scoped=true&ts=true"
import script from "./ListVehicles.vue?vue&type=script&lang=ts"
export * from "./ListVehicles.vue?vue&type=script&lang=ts"

import "./ListVehicles.vue?vue&type=style&index=0&id=dacf8172&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dacf8172"]])

export default __exports__